const STORAGE_KEY = 'doublehelix:recentApps';
const MAX_RECENT = 5;

export function recordVisit(appId: string): void {
  const ids = getRecentAppIds();
  const updated = [appId, ...ids.filter((id) => id !== appId)].slice(0, MAX_RECENT);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // storage unavailable; ignore
  }
}

export function getRecentAppIds(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as string[]) : [];
  } catch {
    return [];
  }
}
